'use client';

import { useEffect } from 'react';

import Head from 'next/head';

const AKCELO_GLOBAL_STYLES = `
  .akcelo-wrapper {
    display: grid;
    place-items: center;
    grid-template-columns: 1fr;
    text-align: center;
    position: relative;
    overflow: hidden;
  }
  .akcelo-wrapper.akcelo-wrapper-label:before {
    content: attr(data-ad-text);
    color: #777777;
    font-size: 11px;
    text-align: center;
    position: absolute;
    width: 100%;
    top: 2px;
  }
  .akcelo-wrapper.akcelo-wrapper-label {
    box-sizing: content-box;
    padding: 20px 0 0;
  }
  .akcelo-placeholder:not(.akcelo-loaded) {
    background-color: #f9f9f9;
    background-clip: content-box;
  }
  .akcelo-placeholder:not(.akcelo-loaded)::after {
    border: 1px solid #696969;
    border-radius: 2px;
    color: #696969;
    content: attr(data-placeholder-text);
    font-size: 11px;
    line-height: 1;
    padding: 3px 4px 1px;
    position: absolute;
    background-color: transparent;
    font-family: Arial,sans-serif;
  }
  .akcelo-video > div:first-child {
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .akcelo-video.akcelo-wrapper-label > div:first-child {
    top: 20px;
  }
  @media (pointer:coarse) {
    .akcelo-wrapper.akcelo-desktop {
      display: none;
    }
  }
  @media (pointer:fine) {
    .akcelo-wrapper.akcelo-mobile {
      display: none;
    }
  }
`;

const AKCELO_STYLES_ID = 'akcelo-global-styles';

type NextAkceloConfigProps = { deferMs?: number };

export const NextAkceloConfig = ({ deferMs = 2000 }: NextAkceloConfigProps) => {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENABLE_AKCELO !== 'true') {
      return undefined;
    }

    if (typeof window === 'undefined') {
      return undefined;
    }

    const injectAkceloStyles = () => {
      if (!document.getElementById(AKCELO_STYLES_ID)) {
        const style = document.createElement('style');
        style.id = AKCELO_STYLES_ID;
        style.textContent = AKCELO_GLOBAL_STYLES;
        document.head.appendChild(style);
      }
    };

    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(
        () => {
          injectAkceloStyles();
        },
        { timeout: deferMs }
      );
    } else {
      timeoutId = setTimeout(injectAkceloStyles, deferMs);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [deferMs]);

  if (process.env.NEXT_PUBLIC_ENABLE_AKCELO !== 'true') {
    return null;
  }

  return (
    <Head>
      <script
        key="akcelo-script"
        async
        src="https://ads.sportslocalmedia.com/slm.prebid.scorenco.js"
      />
    </Head>
  );
};
